import http from "../plugins/Axios";

export default {
  actions: {
    async getProductGroups(_, query) {
      try {
        const {
          data: { data, total },
        } = await http.get("product-group/get-items", {
          params: {
            limit: query && query.limit,
            page: query && query.page && query.page - 1,
            name: query && query.name,
          },
        });
        return {
          data: data.map((item, index) => {
            item.index = query && query.limit * (query.page - 1) + index + 1;
            return item;
          }),
          lastPage: query && Math.ceil(total / query.limit),
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async createProductCategoryGroup(_, payload) {
      try {
        const { data } = await http.post("product-group/save", payload);
        return data;
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async deleteProductGroup(_, id) {
      try {
        await http.delete(`/product-group/delete?id=${id}`);
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
